import React from "react";
import { categories } from "../mock";
import useSiteNav from "../hooks/useSiteNav";
import NewsletterDialog from "./NewsletterDialog";
import Logo from "./Logo";
import { Instagram, Youtube, Linkedin } from "lucide-react";

const TikTok = ({ size = 17 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M16.5 3c.3 2.1 1.5 3.6 3.5 3.9v2.6c-1.2.1-2.4-.2-3.5-.8v5.6c0 3.3-2.3 5.7-5.4 5.7C7.9 20 6 17.9 6 15.2c0-2.6 2-4.6 4.7-4.6.4 0 .8 0 1.2.1v2.7c-.4-.1-.7-.2-1.1-.2-1.2 0-2.1.9-2.1 2.1 0 1.2.9 2.1 2.1 2.1 1.3 0 2.3-1 2.3-2.6V3h3.4z" />
  </svg>
);

const Substack = ({ size = 17 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M22.539 8.242H1.46V5.406h21.08v2.836zM1.46 10.812V24L12 18.11 22.54 24V10.812H1.46zM22.54 0H1.46v2.836h21.08V0z" />
  </svg>
);

const SOCIALS = [
  { Icon: Instagram, href: "https://www.instagram.com/20proofmedia/", label: "Instagram" },
  { Icon: Linkedin, href: "https://www.linkedin.com/company/20-proof-media/", label: "LinkedIn" },
  { Icon: TikTok, href: "https://www.tiktok.com/@20proofmedia", label: "TikTok" },
  { Icon: Youtube, href: "https://www.youtube.com/@20Proofmedia", label: "YouTube" },
  { Icon: Substack, href: "https://substack.com/@20proofmedia", label: "Substack" },
];

const Footer = () => {
  const { goHashSection, goRoute } = useSiteNav();

  return (
    <footer className="bg-neutral-900 text-neutral-100 pt-16 pb-10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-4 gap-12 pb-14 border-b border-neutral-700">
          <div className="md:col-span-2">
            <Logo light className="h-28 w-auto" />
            <p className="font-display italic text-neutral-400 mt-4 max-w-sm">
              Our 20s are hard enough &mdash;<br />don&rsquo;t go through it alone.
            </p>
            <NewsletterDialog
              trigger={
                <button className="mt-6 bg-[#eceae5] hover:bg-white text-neutral-900 font-sans-ui text-sm px-7 py-3.5 rounded-full transition-colors">
                  Subscribe to our newsletter
                </button>
              }
            />
          </div>

          <div>
            <p className="font-sans-ui text-sm uppercase tracking-widest text-neutral-500 mb-4">Explore</p>
            <ul className="flex flex-col gap-3">
              <li><button onClick={() => goHashSection("about")} className="font-display text-lg text-neutral-200 hover:text-white transition-colors">About</button></li>
              <li><button onClick={() => goRoute("/episodes")} className="font-display text-lg text-neutral-200 hover:text-white transition-colors">Episodes</button></li>
              <li><button onClick={() => goRoute("/resources")} className="font-display text-lg text-neutral-200 hover:text-white transition-colors">Resources</button></li>
              <li><button onClick={() => goHashSection("contact")} className="font-display text-lg text-neutral-200 hover:text-white transition-colors">Contact</button></li>
            </ul>
          </div>

          <div>
            <p className="font-sans-ui text-sm uppercase tracking-widest text-neutral-500 mb-4">Topics</p>
            <ul className="flex flex-col gap-3">
              {categories.map((c) => (
                <li key={c.slug}>
                  <button onClick={() => goRoute(`/topics/${c.slug}`)} className="font-display text-lg text-neutral-200 hover:text-white transition-colors">
                    {c.name.charAt(0) + c.name.slice(1).toLowerCase()}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 pt-8">
          <p className="font-sans-ui text-sm text-neutral-500">
            &copy; {new Date().getFullYear()} 20 PROOF Media. All rights reserved.
          </p>
          <div className="flex gap-4">
            {SOCIALS.map(({ Icon, href, label }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                data-testid={`footer-social-${label.toLowerCase()}`}
                className="w-10 h-10 rounded-full border border-neutral-600 flex items-center justify-center hover:bg-white hover:text-neutral-900 transition-colors"
              >
                <Icon size={17} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
